import { formatInTimeZone } from "date-fns-tz";

/**
 * `formatInTimeZone` throws `RangeError: Invalid time value` when given an
 * empty string, so `formatInTimeZone(date || "", ...)` crashes for a
 * null/undefined/empty date. This wrapper guards that case: it returns
 * `fallback` (or `undefined` when none is given) instead of throwing.
 */
export function safeFormatInTimeZone(
  date: string | null | undefined,
  timeZone: string,
  formatStr: string,
  fallback: string,
): string;
export function safeFormatInTimeZone(
  date: string | null | undefined,
  timeZone: string,
  formatStr: string,
): string | undefined;
export function safeFormatInTimeZone(
  date: string | null | undefined,
  timeZone: string,
  formatStr: string,
  fallback?: string,
): string | undefined {
  if (!date) return fallback;
  return formatInTimeZone(date, timeZone, formatStr);
}
